module.exports = __webpack_public_path__ + "img/renliancaiji_bg2.05bbe7b2.png";